const floodRiskGraph = {
	formNodes: {
		form: null,
		postcodeInput: null,
		errorMessage: null,
		getCurrentLocation: null,
	},

	results: {
		container: null,
		title: null,
		section: null,
		change: null,
	},

	errorMessages: {
		invalid: null,
		length: null,
		server: null,
		match: null,
	},

	constituencyLookupUrl: '',
	floodRiskJsonURL: '',

	floodRiskData: {},

	init: () => {
		floodRiskGraph.getFormNodes();
		floodRiskGraph.getBarGraphNodes();
		floodRiskGraph.getErrorMessages();
		floodRiskGraph.getdataUrls();
		floodRiskGraph.parseFloodRiskData();
		floodRiskGraph.addFormSubmitListener();
		floodRiskGraph.setCurrentLocation();
	},

	getdataUrls: () => {
		floodRiskGraph.floodRiskJsonURL = document
			.getElementById('cnfsd-fr-flood-risk-json')
			?.getAttribute('data-json-url');
		floodRiskGraph.constituencyLookupUrl = document
			.getElementById('cnfsd-fr-constituency')
			?.getAttribute('data-json-url');
	},

	getFormNodes: () => {
		//GETS FORM NODES
		floodRiskGraph.formNodes.form = document.getElementById('cnfsd-fr-form');
		floodRiskGraph.formNodes.postcodeInput = document.getElementById('cnfsd-fr-postcode');
		floodRiskGraph.formNodes.getCurrentLocation = document.getElementById('cnfsd-fr-find-location');
		floodRiskGraph.formNodes.errorMessage = floodRiskGraph.formNodes.form.querySelector('.error-message');
	},

	getErrorMessages: () => {
		//GETS ERROR MESSAGES FROM THE FORM INPUT
		if (!floodRiskGraph.formNodes.postcodeInput) return;

		floodRiskGraph.errorMessages.invalid =
			floodRiskGraph.formNodes.postcodeInput.getAttribute('data-error-invalid');
		floodRiskGraph.errorMessages.length = floodRiskGraph.formNodes.postcodeInput.getAttribute('data-error-length');
		floodRiskGraph.errorMessages.server = floodRiskGraph.formNodes.postcodeInput.getAttribute('data-error-server');
		floodRiskGraph.errorMessages.match = floodRiskGraph.formNodes.postcodeInput.getAttribute('data-error-match');
	},

	getBarGraphNodes: () => {
		//GETS NODES TO SHOW THE GRAPH
		floodRiskGraph.results.container = document.getElementById('cnfsd-fr-results');
		floodRiskGraph.results.title = floodRiskGraph.results.container?.querySelector('h3');
		floodRiskGraph.results.section = floodRiskGraph.results.container?.querySelectorAll('.bar-chart__section');
		floodRiskGraph.results.change = document.getElementById('cnfsd-fr-change');
	},

	addFormSubmitListener: () => {
		// ADD E-LISTENERS
		floodRiskGraph.formNodes.form.addEventListener('submit', e => {
			e.preventDefault();
			floodRiskGraph.getUserConstituency(
				floodRiskGraph.formNodes.postcodeInput.value,
				floodRiskGraph.validateUserPostcodeInput
			);
		});
	},

	setCurrentLocation: () => {
		floodRiskGraph.formNodes.getCurrentLocation.addEventListener('click', e => {
			e.preventDefault();
			e.stopPropagation();
			floodRiskGraph.initFindLocation();
		});
	},

	getConstituencyFloodData: data => {
		const { constituencyCode, constituencyName } = data;

		//FLATTEN ARRAY (REMOVE NESTING) AND CREATE NEW ARRAY OF COUNTIES
		const regions = floodRiskGraph.floodRiskData?.flatMap(region => region.counties);

		//FLATTEN THIS ARRAY AGAIN AND CREATE NEW ARRAY OF CONSISTUENCY OBJECTS
		const constituencies = regions?.flatMap(county => county.Constituencies);

		//FIND MATCHING ID
		const constituencyFloodData = constituencies.find(constituency => constituency.id === constituencyCode);

		if (constituencyFloodData) {
			floodRiskGraph.createBarGraph(constituencyFloodData, constituencyName);
		} else {
			floodRiskGraph.setInputInvalid(
				floodRiskGraph.errorMessages.match ||
					'Sorry, we are unable to find your postcode. Please note that information for Scotland and Wales is unavailable at this time.'
			);
		}
	},

	calcPercentageHelper: (total, part) => {
		return (part / total) * 100;
	},

	createBarGraph: (constituencyFloodData, constituencyName) => {
		//FUNCTION TO CONTAIN BAR GRAPH WITH METHODS TO HANDLE SPECIFIC PARTS

		const { 2018: total2018, 2023: total2023, rise, percentageRise } = constituencyFloodData;

		//SET CONSTITUENCY TITLE
		floodRiskGraph.results.title.innerText = `${constituencyName}`;

		//METHOD TO CREATE THE BAR GRAPH
		const setBarValues = () => {
			//TOTAL OF BOTH 2018 AND 2023 DATA IS 100% WITH EACH YEAR BEING REPRESENTED AS A PERCENTAGE OF THAT
			const totalBarValue = total2018 + total2023;

			Array.from(floodRiskGraph.results.section).forEach((section, index) => {
				const bar = section.querySelector('.bar-chart__bar');
				const title = section.querySelector('.bar-chart__section-title').querySelector('span');

				//IF 2018 SECTION
				if (index === 0) {
					const barWidth = floodRiskGraph.calcPercentageHelper(totalBarValue, total2018);
					bar.style.width = `${barWidth}%`;

					title.innerText = `${total2018} Homes*`;
				} else {
					//ELSE IS 2023
					const barWidth = floodRiskGraph.calcPercentageHelper(totalBarValue, total2023);
					bar.style.width = `${barWidth}%`;

					title.innerText = `${total2023} Homes*`;
				}
			});
		};

		// METHOD TO HANDLE THE TOOLTIP BELOW THE GRAPH
		const setTooltip = () => {
			const strongTag = document.createElement('strong');

			let sentenceOpening = 'This is a ';
			let boldText = '';

			//DONE TO HANDLE PERCENTAGE INCREASE FROM 0, CHANGE TO USE REAL RISE FIGURE & HANDLES PERCENT RISE ISSUE IN DATA
			if (total2018 === 0 || total2023 === 0 || isNaN(percentageRise)) {
				boldText = rise > 0 ? `increase of ${Math.abs(rise)} homes *` : `decrease of ${Math.abs(rise)} homes *`;
				sentenceOpening = `This is ${rise > 0 ? 'an ' : 'a '}`;
			} else {
				boldText =
					rise > 0
						? `${Math.abs(percentageRise.toFixed(2))}% increase *`
						: `${Math.abs(percentageRise.toFixed(2))}% decrease *`;
			}

			strongTag.innerText = `${boldText}*`;
			const textNode = document.createTextNode(`${sentenceOpening}`);

			//RESET INNER HTML
			floodRiskGraph.results.change.innerHTML = '';

			//SET TOOLTIP TEXT
			floodRiskGraph.results.change.appendChild(textNode);
			floodRiskGraph.results.change.appendChild(strongTag);
		};

		setBarValues();
		setTooltip();

		//SHOW THE RESULTS
		floodRiskGraph.results.container.classList.remove('display-none');
	},

	parseFloodRiskData: async () => {
		try {
			//CHECK IF FLOOD DATA EXISTS
			if (!floodRiskGraph.floodRiskJsonURL) {
				throw new Error(
					`No node found with the id of: cnfsd-fr-flood-risk-json, and the data attribute of: data-json-url`
				);
			}

			const response = await fetch(floodRiskGraph.floodRiskJsonURL);

			if (!response.ok) {
				throw new Error(`Error status: ${response.status}`);
			}

			const data = await response.json();

			floodRiskGraph.floodRiskData = data;
		} catch {
			floodRiskGraph.setInputInvalid(
				floodRiskGraph.errorMessages.server ||
					'Sorry, we are unable to load flood risk data at the moment. Please try again later.'
			);
		}
	},

	setPostCodeFromLocation: postcode => {
		//SET THE INPUT TO THE LOCATION FROM GEOLOCATION AND PASS TO GET CONSTITUENCY FUNCTION
		floodRiskGraph.formNodes.postcodeInput.value = `${postcode}`;
		floodRiskGraph.getUserConstituency(postcode, floodRiskGraph.validateUserPostcodeInput);
	},

	initFindLocation: () => {
		//FOR GEOLOCATION - ADOPTED FROM PETROL PRICES

		if (typeof google === 'undefined' || !google.maps || !google.maps.Geocoder) {
			console.error('Google Maps API is not available.');
			floodRiskGraph.setInputInvalid(
				floodRiskGraph.errorMessages.location ||
					'Sorry, we are unable to find your location at the moment. Please enter your postcode manually.'
			);
		}

		if ('geolocation' in navigator) {
			// IF GEOLOCATION IS AVAILABLE
			navigator.geolocation.getCurrentPosition(
				function (position) {
					// GET LONG/LAT
					const latitude = position.coords.latitude,
						longitude = position.coords.longitude,
						geocoder = new google.maps.Geocoder();

					const latlng = { lat: latitude, lng: longitude };

					// GENERATE A POSTCODE FROM LONG/LAT
					geocoder.geocode({ location: latlng }, (results, status) => {
						if (status === 'OK') {
							if (results[0]) {
								for (let i = 0; i < results[0].address_components.length; i++) {
									const component = results[0].address_components[i];
									if (component.types.includes('postal_code')) {
										const postalCode = component.short_name;
										// DISPLAY RESULT
										floodRiskGraph.setPostCodeFromLocation(postalCode);
									}
								}
							} else {
								floodRiskGraph.setInputInvalid(
									floodRiskGraph.errorMessages.location ||
										'Sorry, we are unable to find your location at the moment. Please enter your postcode manually'
								);
							}
						} else {
							console.log(`Geocoder failed due to: ${status}`);
							floodRiskGraph.setInputInvalid(
								floodRiskGraph.errorMessages.location ||
									'Sorry, we are unable to find your location at the moment. Please enter your postcode manually'
							);
						}
					});
				},
				function (error) {
					// CATCH ERRORS
					console.log(`Geocoder failed due to: ${error}`);
					floodRiskGraph.setInputInvalid(
						floodRiskGraph.errorMessages.location ||
							'Sorry, we are unable to find your location at the moment. Please enter your postcode manually'
					);
				}
			);
		} else {
			floodRiskGraph.setInputInvalid(
				floodRiskGraph.errorMessages.location ||
					'Sorry, we are unable to find your location at the moment. Please enter your postcode manually'
			);
		}
	},

	getUserConstituency: async (userPostcode, validateInput) => {
		const userInputInvalid = validateInput(userPostcode);

		//USER POSTCODE IS VALID
		if (!userInputInvalid) return;

		try {
			const response = await fetch(`${floodRiskGraph.constituencyLookupUrl}${userPostcode}`);

			if (!response.ok) {
				throw new Error(`HTTP ERROR: Status: ${response.status}`);
			}

			const data = await response.json();

			//CHECK FOR EMPTY OBJECT
			if (!data || typeof data !== 'object' || Object.keys(data).length === 0) {
				throw new Error('EMPTY OBJECT: No match found in dataset');
			}

			floodRiskGraph.getConstituencyFloodData(data);
		} catch (error) {
			console.error(`${error.message || error}`);

			if (error.message.includes('HTTP ERROR')) {
				floodRiskGraph.setInputInvalid(
					floodRiskGraph.errorMessages.server ||
						'Sorry, we are unable to find your postcode at the moment. Please try again later.'
				);
			} else if (error.message.includes('EMPTY OBJECT')) {
				floodRiskGraph.setInputInvalid(
					floodRiskGraph.errorMessages.invalid ||
						"We've been unable to find any properties for that postcode. Check if the postcode is correct and try again."
				);
			} else {
				floodRiskGraph.setInputInvalid(
					floodRiskGraph.errorMessages.server ||
						'Sorry, we are unable to find your postcode at the moment. Please try again later.'
				);
			}
		}
	},

	handleKeyup: e => {
		if (e.key !== 'Enter') {
			floodRiskGraph.removeFieldErrorOnUserInput();
		}
	},

	removeFieldErrorOnUserInput: () => {
		//RESET INPUT TO BASE STATE
		floodRiskGraph.formNodes.form.classList.remove('field-group--error');
		floodRiskGraph.formNodes.errorMessage.innerText = '';

		//REMOVE E-LISTENER
		floodRiskGraph.formNodes.postcodeInput.removeEventListener('keyup', floodRiskGraph.handleKeyup);
	},

	setInputInvalid: errorMessage => {
		floodRiskGraph.formNodes.errorMessage.innerText = `${errorMessage}`;
		floodRiskGraph.formNodes.form.classList.add('field-group--error');

		//ADDS EVENT LISTENER WHEN USER BEGINS CHANGING POSTCODE INPUT
		floodRiskGraph.formNodes.postcodeInput.addEventListener('keyup', floodRiskGraph.handleKeyup);
	},

	validateUserPostcodeInput: userPostcode => {
		let validInput = true;
		const postcodeRegex = /^[A-Z]{1,2}\d[A-Z\d]?\d[A-Z]{2}$/i;

		//REMOVE WHITE SPACES
		const postCodeTrimmed = userPostcode.replace(/\s+/g, '').trim();

		if (postCodeTrimmed.length < 5 || postCodeTrimmed.length > 7 || !postcodeRegex.test(postCodeTrimmed)) {
			floodRiskGraph.setInputInvalid(
				floodRiskGraph.errorMessages.length || 'Enter a valid postcode between 5 and 7 characters long'
			);
			validInput = false;
		}

		return validInput;
	},
};

document.addEventListener('DOMContentLoaded', function () {
	const floodRisk = document.getElementById('cnfsd-fr');

	if (floodRisk) {
		floodRiskGraph.init();
	}
});
